module.exports = __webpack_public_path__ + "static/media/H-button.d78a67d7.svg";